import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../global/custom-validate';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {DocumentFolderService} from '../../../service/folder/service-documentfolder';
import {Sessioncommand} from '../../../global/sessioncommand';
import {DocumentFolder} from '../../../models/folder/documentfolder';
import {DocumentHoSoFile} from '../../../models/folder/documenthosofile';
import {NodeSelectEventArgs, TreeViewComponent} from '@syncfusion/ej2-angular-navigations';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {DocumentHoSoFileService} from '../../../service/folder/service-documenthosofile';
@Component({
  templateUrl: './select.component.html'

})
export class SelectFolderComponent implements OnInit, AfterViewInit {


  public language = language;
  public submitValidate = false;
  public hoSoId: number;
  public onClose: Subject<boolean>;
  public fieldTree: Object;
  public dataTree: DocumentFolder[];
  public dataFolder: Object[] = [];
  public dataId: number =0;
  public dataFiles: DocumentHoSoFile[] = [];
  public showCheckBox: boolean = true;
  @ViewChild('treeview') public tree: TreeViewComponent;
  constructor( public documentFolderService: DocumentFolderService,
               public documentHoSoFileService: DocumentHoSoFileService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public _bsModalRef: BsModalRef,
               public bsModalService: BsModalService

  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.showTree();


  }
  public edit(id: number) {
    this.hoSoId = id;
  }

  showTree()
  {
    this.documentFolderService.findAllByStaffId(Sessioncommand.staffId).subscribe(x => {
      this.dataTree = x;
      this.dataFolder = [];
      for (let i = 0; i < this.dataTree.length; i++) {
        this.dataFolder.push(
          this.dataTree[i].parentId == 0 ?
            {
              id: this.dataTree[i].id,
              name: this.dataTree[i].name,
              hasChild: this.dataTree[i].hasChild,
              icon: 'icon-folder-alt',
              expanded: true
            }
            :
            {
              id: this.dataTree[i].id,
              pid: this.dataTree[i].parentId,
              name: this.dataTree[i].name,
              hasChild: this.dataTree[i].hasChild,
              icon: 'icon-folder',
              expanded: false
            });
      }
      this.fieldTree = {dataSource: this.dataFolder, id: 'id', parentID: 'pid', text: 'name', iconCss: 'icon', hasChildren: 'hasChild'};

    });
  }
  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }
  public nodeChecked(e: NodeSelectEventArgs): void {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_save_drive,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
          this.saveFile(Number(this.tree.selectedNodes[0]));
      }
    });

  }
  saveFile(folderId: number)
  {
    this.documentHoSoFileService.addFileHoSo(folderId, this.hoSoId).subscribe({
      next: (data) => {
        this.toastr.success(language.success_save_drive, language.message);
        this.onConfirm();
      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
}

